import {useEffect, useState} from "react";
import {AuthRedirectAdmins, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading, ShowProgressLoading} from "../../../components/template/architecture";
import {Link, useNavigate} from "react-router-dom";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {BreadCrumbs} from "../../../components/open/pages";
import {
    CheckIcon,
    SearchIcon,
    ThinAddIcon,
    ThinChart2Icon,
    ThinCheckListIcon,
    ThinEditIcon,
    ThinEditNoteIcon,
    ThinNotAllowedIcon, ThinPrintIcon,
    ThinPrivacyIcon,
    ThinTimeIcon,
    ThinTrashIcon,
    ThinVisibilityOffIcon,
    ThinVisibilityOnIcon,
    TomansIcon
} from "../../../components/icons/material-icons";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {GradeToString} from "../students/list";
import {GregorianToPersian} from "../../../components/techaran/date-convert";
import '../../../static/css/pages/pre-signup/admin-pre-signup.css';
import {AdminsPresignupApproveModal} from "./approve-modal";
import {AdminsPresignupEditPrePaymentPriceModal} from "./edit-pre-payment";
import {RemoveModal} from "../../../components/template/remove-modal";
import {AdminsPresignupPickOldStudentsModal} from "./pick-students";
import {AdminsPresignupAddEditStudentModal} from "./add-edit-student";
import {AdminsPresignupEnableDisableModal} from "./enable-signup";
import {AdminsSignupTermsModal} from "./terms-modal";

interface studentInterface {
    id: number,
    name: string,
    tell: string,
    national: string,
    grade: number,
    price: number,
    approved: boolean,
    approvedAt: string,
    createdAt: string,
    isPaid: boolean,
    paidAt: string,
    refNum: string,
    traceNo: string,
    rrn: string,
    securePan: string,
    declined: boolean,
}

export const AdminsPresignupScreen = () => {
    const [list, setList] = useState<studentInterface[]>([]);
    const [enabled, setEnabled] = useState(false);
    const [tempDisable,setTempDisable] = useState(false);
    const [loaded, setLoaded] = useState(false);
    const navigate = useNavigate();
    const fetchList = () => {
        PostJSON(
            Apis.server + '/core/admins/presignup/list',
            {},
            true,
            (d: {
                result: string,
                reason: string,
                list: studentInterface[] | null,
                enabled: boolean,
                temp:boolean,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectAdmins();
                    else if (d.reason === 'access') {
                        ShowSnackbar(
                            'شما به این بخش دسترسی ندارید.',
                            'باشه',
                            5000,
                        );
                        navigate('/admins', {replace: true});
                    }
                    return;
                }
                setList(d.list === null ? [] : d.list);
                setEnabled(d.enabled);
                setLoaded(true);
                setTempDisable(d.temp);
            },
            () => {
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    const [termsModal, setTermsModal] = useState(false);
    useEffect(() => {
        document.title = "پیش ثبت‌نام | اتوماسیون نهال";
        fetchList();
    }, []);
    const [search, setSearch] = useState('');
    useEffect(() => {
        if (!loaded || list.length < 1)
            return;
        const filter = search.toUpperCase().trim();
        const lst = document.querySelector('.presignup-table');
        const btns = (lst as HTMLDivElement).getElementsByTagName('tr');
        for (let i = 0; i < btns.length; i++) {
            const b = btns[i].getElementsByTagName('span')[0];
            if (typeof b === "undefined")
                continue;
            const v = b.innerHTML.toUpperCase();
            const noSpace = v.replaceAll(' ', '');
            if (v.indexOf(filter) > -1 || noSpace.indexOf(filter.replaceAll(' ', '')) > -1)
                btns[i].style.display = "";
            else
                btns[i].style.display = "none";
        }
    }, [search]);
    const [approveModal, setApproveModal] = useState({
        show: false,
        name: '',
        id: 0,
        decline: false,
    });
    const [editPrePayment, setEditPrePayment] = useState({
        show: false,
        name: '',
        id: 0,
        price: 0,
    });
    const [removeModal, setRemoveModal] = useState({
        show: false,
        id: 0,
        name: '',
    });
    const [pickModal, setPickModal] = useState(false);
    const [addEdit, setAddEdit] = useState({
        show: false,
        edit: false,
        id: 0,
    });
    const [enableModal, setEnableModal] = useState(false);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'اتوماسیون', url: '/admins/'},
                {title: 'پیش ثبت‌نام', url: '/admins/presignup'},
            ]}/>
            {
                loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="screen-card">
                            <div className="screen-card-header">
                                <b>پیش ثبت‌نام</b>
                                <div className="d-inline-flex align-items-center" style={{gap: 5}}>
                                    <button onClick={()=>window.open("/print/admins/signup")}>
                                        <ThinPrintIcon/>
                                        <span>پرینت</span>
                                    </button>
                                    <Link to={"insights"}>
                                        <ThinChart2Icon/>
                                        <span>آمار</span>
                                    </Link>
                                    <button onClick={() => setTermsModal(true)}>
                                        <ThinPrivacyIcon/>
                                        <span>ویرایش قوانین</span>
                                    </button>
                                    <button onClick={() => setPickModal(true)}>
                                        <ThinCheckListIcon/>
                                        <span>افزودن از سال جاری</span>
                                    </button>
                                    <button onClick={() => setEnableModal(true)}>
                                        {enabled ? <ThinVisibilityOnIcon/> : <ThinVisibilityOffIcon/>}
                                        <span>{enabled ? 'فعال' : 'غیرفعال'}</span>
                                    </button>
                                    <button onClick={() => setAddEdit({
                                        show: true,
                                        id: 0,
                                        edit: false,
                                    })}>
                                        <ThinAddIcon/>
                                        <span>افزودن</span>
                                    </button>
                                </div>
                            </div>
                            <div className="pick-device-search">
                                <button><SearchIcon/></button>
                                <input type="text"
                                       value={search}
                                       onChange={e => setSearch(e.currentTarget.value)}
                                       onBlur={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.remove('active')}
                                       onFocus={() => (document.querySelector('.pick-device-search') as HTMLDivElement).classList.add('active')}
                                       className="f-roboto"
                                       placeholder={"جستجو دانش‌آموز..."}
                                />
                            </div>
                            <table
                                className="table open-table table-bordered table-striped table-hover presignup-table-main">
                                <thead>
                                <tr>
                                    <th>#</th>
                                    <th>نام</th>
                                    {/*<th>کد ملی</th>*/}
                                    <th>تلفن</th>
                                    <th>پایه</th>
                                    <th>پیش پرداخت</th>
                                    <th>وضعیت</th>
                                    <th>پرداخت</th>
                                    <th>تاریخ پرداخت</th>
                                    <th>تاریخ ایجاد</th>
                                    <th>امکانات</th>
                                </tr>
                                </thead>
                                <tbody className="presignup-table">
                                {
                                    list.map((s, i) =>
                                        <tr key={"Xs9SSj_2sssJDK" + i}>
                                            <td>{StringDigitsConvertToPersian(i + 1)}</td>
                                            <td><Link to={`/admins/presignup/view/${s.id}`}>{s.name}</Link></td>
                                            {/*<td>{StringDigitsConvertToPersian(s.national)}</td>*/}
                                            <td>{StringDigitsConvertToPersian(s.tell.replaceAll('+98', '0'))}</td>
                                            <td>{GradeToString(s.grade)}</td>
                                            <td><span>{CurrencyFormat(s.price)}<TomansIcon/></span></td>
                                            <td>
                                                {
                                                    s.approved ?
                                                        <em data-color="green"><CheckIcon/>تایید شده</em> :
                                                        (s.declined ?
                                                                <em data-color="red"><ThinNotAllowedIcon/>رد شده</em> :
                                                                <em data-color="brown"><ThinTimeIcon/>در انتظار</em>
                                                        )
                                                }
                                            </td>
                                            <td>
                                                {
                                                    s.isPaid ?
                                                        <em data-color="green"><CheckIcon/>پرداخت شده</em> :
                                                        <em data-color="red"><ThinNotAllowedIcon/>عدم پرداخت</em>
                                                }
                                            </td>
                                            <td>{s.isPaid ? (StringDigitsConvertToPersian(s.paidAt.split(' ')[1] + " " + GregorianToPersian(s.paidAt.split(' ')[0]).replaceAll('-', '/'))) : '-'}</td>
                                            <td>{StringDigitsConvertToPersian(s.createdAt.split(' ')[1] + " " + GregorianToPersian(s.createdAt.split(' ')[0]).replaceAll('-', '/'))}</td>
                                            <td>
                                                <div className="d-inline-flex justify-content-center align-items-center"
                                                     style={{gap: 5}}>
                                                    {
                                                        !s.approved && !s.declined ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => setApproveModal({
                                                                        show: true,
                                                                        name: s.name,
                                                                        id: s.id,
                                                                        decline: false,
                                                                    })}>
                                                                <i>تایید ثبت‌نام</i>
                                                                <CheckIcon/>
                                                            </button> : null
                                                    }
                                                    {
                                                        !s.approved && !s.declined ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => setApproveModal({
                                                                        show: true,
                                                                        name: s.name,
                                                                        id: s.id,
                                                                        decline: true,
                                                                    })}>
                                                                <i>رد درخواست</i>
                                                                <ThinNotAllowedIcon/>
                                                            </button> : null
                                                    }
                                                    {
                                                        !s.isPaid ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => setEditPrePayment({
                                                                        show: true,
                                                                        name: s.name,
                                                                        id: s.id,
                                                                        price: s.price,
                                                                    })}>
                                                                <i>ویرایش پیش‌پرداخت</i>
                                                                <ThinEditNoteIcon/>
                                                            </button> : null
                                                    }
                                                    <button className="open-tooltip"
                                                            onClick={() => setAddEdit({
                                                                show: true,
                                                                edit: true,
                                                                id: s.id,
                                                            })}>
                                                        <i>ویرایش دانش‌آموز</i>
                                                        <ThinEditIcon/>
                                                    </button>
                                                    {
                                                        !s.isPaid ?
                                                            <button className="open-tooltip"
                                                                    onClick={() => setRemoveModal({
                                                                        show: true,
                                                                        name: s.name,
                                                                        id: s.id,
                                                                    })}>
                                                                <i>حذف</i>
                                                                <ThinTrashIcon/>
                                                            </button> : null
                                                    }
                                                </div>
                                            </td>
                                        </tr>
                                    )
                                }
                                </tbody>
                            </table>
                        </div>
                    </div> : null
            }
            <AdminsPresignupApproveModal
                active={approveModal.show}
                closeHandler={() => setApproveModal(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                studentId={approveModal.id}
                name={approveModal.name}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
                decline={approveModal.decline}
            />
            <AdminsPresignupEditPrePaymentPriceModal
                active={editPrePayment.show}
                closeHandler={() => setEditPrePayment(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                name={editPrePayment.name}
                id={editPrePayment.id}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
                currentPrice={editPrePayment.price}
            />
            <RemoveModal
                active={removeModal.show}
                closeHandler={() => setRemoveModal(v => {
                    let x = {...removeModal};
                    x.show = false;
                    return x;
                })}
                title={"حذف دانش آموز"}
                desc={`آیا مطمئن هستید که می‌خواهید ${removeModal.name} را از لیست پیش‌ثبت نام حذف کنید؟`}
                onRemove={() => {
                    const x = {...removeModal};
                    ShowProgressLoading();
                    PostJSON(
                        Apis.server + '/core/admins/presignup/remove',
                        {
                            id: x.id.toString(),
                        },
                        true,
                        (d: {
                            result: string,
                            reason: string,
                        }) => {
                            HideProgressLoading();
                            if (d.result !== 'OK') {
                                if (d.reason === 'login')
                                    AuthRedirectAdmins();
                                return;
                            }
                            ShowSnackbar(
                                'دانش آموز حذف شد.',
                                'باشه',
                                5000,
                            );
                            ShowProgressLoading();
                            fetchList();
                        },
                        () => {
                        },
                        AuthRedirectAdmins,
                    ).then(void 0);
                }}
            />
            <AdminsPresignupPickOldStudentsModal
                active={pickModal}
                closeHandler={() => setPickModal(false)}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
            />
            <AdminsPresignupAddEditStudentModal
                active={addEdit.show}
                closeHandler={() => setAddEdit(v => {
                    let x = {...v};
                    x.show = false;
                    return x;
                })}
                studentId={addEdit.id}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
                edit={addEdit.edit}
            />
            <AdminsPresignupEnableDisableModal
                active={enableModal}
                closeHandler={() => setEnableModal(false)}
                isEnable={enabled}
                onDone={() => {
                    ShowProgressLoading();
                    fetchList();
                }}
                tempDisable={tempDisable}
            />
            <AdminsSignupTermsModal
                active={termsModal}
                closeHandler={() => setTermsModal(false)}
            />
        </>
    );
};